import { render, staticRenderFns } from "./signForm.vue?vue&type=template&id=71625a64&scoped=true&"
import script from "./signForm.vue?vue&type=script&lang=js&"
export * from "./signForm.vue?vue&type=script&lang=js&"
import style0 from "./signForm.vue?vue&type=style&index=0&id=71625a64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71625a64",
  null
  
)

export default component.exports